export const preview = (file, cancel) => {
    try {
        if (file) {
            if (file.type.indexOf('image') > -1) {
                !cancel ? previewInit(file, '_image') : previewCancel('_image');
            }
            if (file.type.indexOf('video') > -1) {
                !cancel ? previewInit(file, '_videoPlayer') : previewCancel('_videoPlayer');
            }
            if (file.type.indexOf('audio') > -1) {
                !cancel ? previewInit(file, '_audioPlayer') : previewCancel('_audioPlayer');
            }
            if (file.type.indexOf('pdf') > -1) {
                !cancel ? previewInit(file, '_pdf') : previewCancel('_pdf');
            }
            if (file.type.indexOf('json') > -1) {
                !cancel ? previewInit(file, '_json') : previewCancel('_json');
            }
        }
    } catch (e) {

    }
}

export const previewInit = (file, domId) => {
    if (file) {
        let logo_url = URL.createObjectURL(file);
        const oLogo = document.getElementById(domId);
        oLogo && (oLogo.src = logo_url);
        if (domId !== '_image') {
          //  oLogo.setAttribute('type','application/pdf');
            oLogo.setAttribute('height', '100%');
        }
    }
}

export const previewCancel = (domId) => {
    const oLogo = document.getElementById(domId);
    oLogo && (oLogo.src = '');
}
